/**
 * Conversions between Date values and date-only "YYYY-MM-DD" strings
 * (the format Stencil's PopupDatePicker works with).
 */

/**
 * Formats a Date (or parseable timestamp) as a UTC date-only string,
 * e.g. "2026-06-10". Returns '' for missing/invalid input so pickers
 * can treat it as unset.
 *
 * Uses UTC getters deliberately: due dates are stored as UTC midnight
 * (see parseDateOnlyAsUtc), so local getters would render the previous
 * day in negative-UTC timezones (e.g. all US timezones).
 */
export function toDateOnlyString(date: Date | string | number | undefined): string {
  if (date === undefined || date === null || date === '') return '';
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * Parses a date-only string as UTC midnight — the wire convention the
 * task APIs use for due dates (mirrors the desktop task page, which
 * sends `new Date(dateStr + 'T00:00:00.000Z')`).
 */
export function parseDateOnlyAsUtc(dateStr: string): Date {
  return new Date(`${dateStr}T00:00:00.000Z`);
}
